<template>
  <div
    v-if="show"
    class="yhc-service-level-info__content-office yhc-service-level-info__content-office--bottom"
  >
    <div class="yhc-service-level-info__section yhc-service-level-info__section--store-info">
      <div class="yhc-service-level-info__label">
        <Icon
          name="Office"
          class="yhc-service-level-info__icon"
        />
        <span>担当店情報</span>
        <span class="yhc-service-level-info__annotation">
          ※この箇所は社内用ページでのみ表示されます。
        </span>
      </div>
      <div class="yhc-service-level-info__office-section yhc-service-level-info__office-section--display">
        <div class="yhc-service-level-info__office-pair">
          <div class="yhc-service-level-info__office-column">
            <div class="yhc-service-level-info__office-side-label">
              お預かり先
              <span
                v-if="showFromYtcNote"
                class="yhc-service-level-info__annotation"
              >※YTCエリアです</span>
            </div>
            <div class="yhc-service-level-info__office-name">{{ fromHeading }}</div>
            <div
              v-for="(line, idx) in fromDetailLines"
              :key="'from-office-line-' + idx"
              class="yhc-service-level-info__office-line"
            >
              {{ line }}
            </div>
          </div>
          <div class="yhc-service-level-info__office-column">
            <div class="yhc-service-level-info__office-side-label">
              お届け先
              <span
                v-if="showToYtcNote"
                class="yhc-service-level-info__annotation"
              >※YTCエリアです</span>
            </div>
            <div class="yhc-service-level-info__office-name">{{ toHeading }}</div>
            <div
              v-for="(line, idx) in toDetailLines"
              :key="'to-office-line-' + idx"
              class="yhc-service-level-info__office-line"
            >
              {{ line }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import Icon from './ui/icons/index.vue'

export default defineComponent({
  name: 'YhcServiceLevelInfoOffice',
  components: {
    Icon,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    fromHeading: {
      type: String,
      required: true,
    },
    toHeading: {
      type: String,
      required: true,
    },
    fromDetailLines: {
      type: Array as PropType<string[]>,
      required: true,
    },
    toDetailLines: {
      type: Array as PropType<string[]>,
      required: true,
    },
    showFromYtcNote: {
      type: Boolean,
      default: false,
    },
    showToYtcNote: {
      type: Boolean,
      default: false,
    },
  },
})
</script>
